import { autocompleteClasses } from '@mui/material/Autocomplete';
import { Theme } from '@mui/material/styles';
import SvgIcon, { svgIconClasses, SvgIconProps } from '@mui/material/SvgIcon';

import { menuItem, paper, varAlpha } from '../styles/index.js';

// ----------------------------------------------------------------------

/**
 * Icons
 * https://icon-sets.iconify.design/eva/arrow-ios-downward-fill/
 */
const ArrowDownIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15a1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16"
      fill="currentColor"
    />
  </SvgIcon>
);

// ----------------------------------------------------------------------

const MuiAutocomplete = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { popupIcon: <ArrowDownIcon /> },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      [`& span.${autocompleteClasses.tag}`]: {
        ...theme.typography.subtitle2,
        height: 24,
        minWidth: 24,
        lineHeight: '24px',
        textAlign: 'center',
        padding: theme.spacing(0, 0.75),
        color: theme.palette.text.secondary,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: varAlpha((theme.palette.grey as any)['500Channel'], 0.16),
      },
    }),
    paper: ({ theme }: { theme: Theme }) => ({ ...paper({ theme, dropdown: true }) }),
    listbox: ({ theme }: { theme: Theme }) => ({
      padding: 0,
      maxHeight: 200,
      [`& .${autocompleteClasses.option}`]: { ...menuItem(theme) },
    }),
    endAdornment: { [`& .${svgIconClasses.root}`]: { width: 18, height: 18 } },
  },
};

// ----------------------------------------------------------------------

export const autocomplete = { MuiAutocomplete };
